import Page from "webPage/Page";
import {handleScrollingSection} from "util/scrolling-section";
import $ from "jquery";

Page.register('post-type-archive-case-studies', () => {
    handleScrollingSection($('.js-scrolling-logos'));
    handleScrollingSection($('.js-scrolling-logos-left'), "left");
});
